import { render, staticRenderFns } from "./CellRenderMarque.vue?vue&type=template&id=8f6808a6&"
import script from "./CellRenderMarque.vue?vue&type=script&lang=js&"
export * from "./CellRenderMarque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports